<template>
  <v-card-title class="w-100">
    <div class="d-flex">
      <div
        :style="{background:bgColor}"
        class="circle-icon-wrapper mr-5"
        :class="{ 'pointer': showEditOfSharing }"
        @click.stop="showEditOfSharing ? setShowEditOfSharing(!showEditOfSharing) : null">
        <v-icon
          v-if="!showEditOfSharing"
          size="20"
          color="grey">
          mdi-account-plus-outline
        </v-icon>
        <v-icon
          v-else
          size="20"
          color="#fff">
          mdi-arrow-left
        </v-icon>
      </div>
      <div
        class="align-self-center"
        :style="{color: colorTitle}">
        <span v-if="dialogType === TYPE_COLLECTION_SHARE">{{ headerTitle }}</span>
        <span v-else>Invite members</span>
        <p
          :style="{color: colorTitle}"
          class="body-2">
          <slot name="subtitle" />
        </p>
      </div>
    </div>
    <v-icon
      v-if="closedIcon"
      class="closed align-self-start"
      color="#fff"
      @click.stop="closeButton">
      mdi-close
    </v-icon>
  </v-card-title>
</template>
<script>
import { TYPE_COLLECTION_SHARE } from '@/constants';
import {
  mapMutations, mapState,
} from 'vuex';
export default {
  name: 'HeaderShare',
  props: {
    closedIcon: {
      type: Boolean,
      default: true,
    },
    headerTitle: {
      type: String,
      default: 'Share and add members',
    },
    colorTitle: {
      type: String,
      default: '#fff',
    },
    bgIconColor: {
      type: String,
      default: 'lightBlue',
    },
    dialogType: {
      type: String,
      default: TYPE_COLLECTION_SHARE,
    },
  },
  data() {
    return {
      TYPE_COLLECTION_SHARE,
    };
  },
  computed: {
    ...mapState('Collections', ['showEditOfSharing']),
    bgColor() {
      return `var(--v-${this.bgIconColor}-base)`;
    },
  },
  methods: {
    ...mapMutations('Collections', ['setShowEditOfSharing']),
    closeButton() {
      if (this.showEditOfSharing) {
        this.setShowEditOfSharing(!this.showEditOfSharing);
      } else {
        this.$emit('closeModal');
      }
    },
  },
};
</script>
<style
  lang="scss"
  scoped>
.closed {
  margin-left: auto;
}
p{
  margin: 0 !important;
}
</style>

